// models/gantt-detail.model.ts

import { VehicleChassisTypeEnum } from 'src/app/enum/vehicle-chassis-type.enum';
import { VehicleFuelTypeEnum } from 'src/app/enum/vehicle-fuel.enum';

export interface GetSideBarGanttDataRequest {
  nodeId: string;
  isService: boolean;
  originNodeId?: string;
}

export interface ServiceLocation {
  address: string;
  latitude: number;
  longitude: number;
}

export interface VehicleInformation {
  vehicleType: VehicleChassisTypeEnum;
  brand: string;
  model: string;
  licensePlate: string;
  fuelType: VehicleFuelTypeEnum;
}

export interface DriverInformation {
  driverName: string;
  isNodeLockedForDriverAssignation?: boolean;
  isNodeLockedForSweeperDriverAssignation?: boolean;
  isNodeLockedForSweeperAssignation?: boolean;
}

export interface RouteInformation {
  assignedDate: ZonedDateDto;
  startDate: ZonedDateDto | null;
  endDate: ZonedDateDto | null;
  driverData: DriverInformation | null;
  sweeperDriverData: DriverInformation | null;
}

export type DelayCausedBy = 'CLIENT' | 'CAFLER';

export enum DelayType {
  UNDEFINED = 0,
  CLIENT = 1,
  CAFLER = 2,
}

export type CancelBy = 'CLIENT' | 'CAFLER';

export enum CancelType {
  CLIENT = 1,
  CAFLER = 2,
}

export enum CancelRefundType {
  Refund0 = 1,
  Refund100 = 2,
}

import { ServiceTypeMobility } from 'src/app/enum/service-type-mobility.enum';

export interface GetSideBarGanttDataResponse {
  isServiceDelayed: boolean;
  delayReasonGuid: string;
  delayType: DelayType;
  nodeId: string;
  productName: string;
  clientName: string;
  zoneName: string;
  originLocation: ServiceLocation;
  destinationLocation: ServiceLocation;
  vehicleInformation: VehicleInformation;
  routeInformation: RouteInformation;
  providerUbication: ServiceLocation[];
  zoneGuid: string;
  clientComments: string;
  nodeStatus?: number;
  serviceTypeMobility?: ServiceTypeMobility | null;
  startDate?: ZonedDateDto | null;
  endDate?: ZonedDateDto | null;
}

export interface ServiceLocation {
  address: string;
  latitude: number;
  longitude: number;
}

export interface ZonedDateDto {
  completeDate?: string | null;
  date?: string | null;
  time?: string | null;
  offset?: string | null;
  timeZone?: string | null;
  _completeDate?: string | null;
  _date?: string | null;
  _time?: string | null;
  _offset?: string | null;
  _timeZone?: string | null;
}

export interface UpdateSidebarRequest {
  originLocation: ServiceLocation;
  destinationLocation: ServiceLocation;
  startDate: ZonedDateDto;
  endDate: ZonedDateDto;
  serviceStartDate?: ZonedDateDto | null;
  serviceEndDate?: ZonedDateDto | null;
  brand?: string | null;
  model?: string | null;
  licensePlate?: string | null;
  nodeId: string;
  nodeStatus?: number | null;
  failureReasonGuid?: string | null;
  otherReason?: string | null;
}

export interface BooleanResponse {
  isSuccess: boolean;
}
